import React from 'react';
import { Icon } from 'react-feather';
import LogOut from 'react-feather/dist/icons/log-out';
import Terminal from 'react-feather/dist/icons/terminal';
import File from 'react-feather/dist/icons/file';
import List from 'react-feather/dist/icons/list';
import Info from 'react-feather/dist/icons/info';
import Eye from 'react-feather/dist/icons/eye';
import Activity from 'react-feather/dist/icons/activity';
import BarChart2 from 'react-feather/dist/icons/bar-chart-2';
import HardDrive from 'react-feather/dist/icons/hard-drive';
import Download from 'react-feather/dist/icons/download';
import Check from 'react-feather/dist/icons/check';
import X from 'react-feather/dist/icons/x';
import Monitor from 'react-feather/dist/icons/monitor';
import Copy from 'react-feather/dist/icons/copy';
import Maximize2 from 'react-feather/dist/icons/maximize-2';
import Minimize2 from 'react-feather/dist/icons/minimize-2';
import Clipboard from 'react-feather/dist/icons/clipboard';
import Maximize from 'react-feather/dist/icons/maximize';
import ZoomIn from 'react-feather/dist/icons/zoom-in';
import ZoomOut from 'react-feather/dist/icons/zoom-out';
import ArrowDown from 'react-feather/dist/icons/arrow-down';
import ArrowUp from 'react-feather/dist/icons/arrow-up';
import ArrowLeft from 'react-feather/dist/icons/arrow-left';
import ArrowRight from 'react-feather/dist/icons/arrow-right';
import Search from 'react-feather/dist/icons/search';
import Filter from 'react-feather/dist/icons/filter';
import Folder from 'react-feather/dist/icons/folder';
import Upload from 'react-feather/dist/icons/upload';
import RefreshCw from 'react-feather/dist/icons/refresh-cw';
import Play from 'react-feather/dist/icons/play';
import Square from 'react-feather/dist/icons/square';
import Loader from 'react-feather/dist/icons/loader';
import Settings from 'react-feather/dist/icons/settings';
import AlertCircle from 'react-feather/dist/icons/alert-circle';
import AlertTriangle from 'react-feather/dist/icons/alert-triangle';
import AlertOctagon from 'react-feather/dist/icons/alert-octagon';
import Key from 'react-feather/dist/icons/key';
import Lock from 'react-feather/dist/icons/lock';
import Archive from 'react-feather/dist/icons/archive';
import Delete from 'react-feather/dist/icons/delete';
import Edit from 'react-feather/dist/icons/edit';
import FolderPlus from 'react-feather/dist/icons/folder-plus';
import Menu from 'react-feather/dist/icons/menu';
import UploadCloud from 'react-feather/dist/icons/upload-cloud';
import Box from 'react-feather/dist/icons/box';

export const Icons = {
  alertCircle: AlertCircle as Icon,
  alertTriangle: AlertTriangle as Icon,
  alertOctagon: AlertOctagon as Icon,
  key: Key as Icon,
  lock: Lock as Icon,
  logOut: LogOut as Icon,
  terminal: Terminal as Icon,
  file: File as Icon,
  list: List as Icon,
  info: Info as Icon,
  eye: Eye as Icon,
  activity: Activity as Icon,
  barChart2: BarChart2 as Icon,
  hardDrive: HardDrive as Icon,
  download: Download as Icon,
  check: Check as Icon,
  x: X as Icon,
  monitor: Monitor as Icon,
  copy: Copy as Icon,
  maximize2: Maximize2 as Icon,
  minimize2: Minimize2 as Icon,
  clipboard: Clipboard as Icon,
  maximize: Maximize as Icon,
  zoomIn: ZoomIn as Icon,
  zoomOut: ZoomOut as Icon,
  arrowDown: ArrowDown as Icon,
  arrowUp: ArrowUp as Icon,
  search: Search as Icon,
  filter: Filter as Icon,
  folder: Folder as Icon,
  arrowLeft: ArrowLeft as Icon,
  arrowRight: ArrowRight as Icon,
  upload: Upload as Icon,
  refreshCw: RefreshCw as Icon,
  play: Play as Icon,
  square: Square as Icon,
  loader: Loader as Icon,
  settings: Settings as Icon,
  archive: Archive as Icon,
  delete: Delete as Icon,
  edit: Edit as Icon,
  folderPlus: FolderPlus as Icon,
  menu: Menu as Icon,
  uploadCloud: UploadCloud as Icon,
  box: Box as Icon,
};

export type IconsKey = keyof typeof Icons;

export const sizeToPx = (size: Size) => {
  switch (size) {
    case 'big':
      return 25;
    case 'normal':
      return 20;
    case 'small':
      return 15;
  }

  const _exhaustiveCheck: never = size;
};

export type GlyphiconProps = {
  glyph: IconsKey;
  size?: Size;
  color?: React.CSSProperties['color'];
} & Stylable;

export const Glyphicon: React.SFC<GlyphiconProps> = ({
  glyph,
  size,
  ...rest
}) =>
  React.createElement(Icons[glyph], {
    size: sizeToPx(size || 'normal'),
    ...rest,
  });
